import { render, staticRenderFns } from "./Spells.vue?vue&type=template&id=34c9ea48&"
import script from "./Spells.vue?vue&type=script&lang=js&"
export * from "./Spells.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports